import _ from "lodash";
/**
 *
 * @param {*} instruction
 * @param {*} presetPrompts
 * @returns Ordered prompts
 */
export const getOrderedPrompts = (instruction, presetPrompts) => {
  const selectedPrompt = _.get(instruction, "selectedPrompt");

  // * Filtering prompt such that it already present in the instruction
  const filteredPrompts = _.filter(
    presetPrompts,
    prompt =>
      !selectedPrompt ||
      selectedPrompt !== _.get(prompt, "metadata.presetPrompt")
  );

  // * Sorting the prompts based on displaySequence
  return _.orderBy(filteredPrompts, "displaySequence");
};

/**
 *
 * @param {*} instruction
 * @param {*} presetPrompts
 * @returns Checking if preset prompt is in use
 */
export const isUsingPresetPrompt = (instruction, presetPrompts) => {
  if (!instruction) return false;

  const selectedPrompt = _.get(instruction, "selectedPrompt");
  if (!selectedPrompt) return false;

  // Check if the instruction starts with any of the preset prompts
  const isUsing = _.some(presetPrompts, prompt => {
    const promptText = _.get(prompt, "metadata.presetPrompt", "");
    return promptText === selectedPrompt;
  });

  return isUsing;
};
